import { Component, inject, OnInit, viewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";

import { AdaaHelper } from "../../../../core/utils";
import { DataTableComponent } from "../../../../shared/components/table/data-table/data-table";
import { Constants } from "../../../../shared/constants/constants";
import { TableActionEvent } from "../../../../shared/models";
import { SystemLayoutService } from "../../../../shared/services";

@Component({
  selector: "adaa-forecasted-values-metrics-list",
  imports: [TranslatePipe, DataTableComponent],
  templateUrl: "./forecasted-values-metrics-list.html",
  styleUrl: "./forecasted-values-metrics-list.scss",
})
export class ForecastedValuesMetricsListComponent implements OnInit {
  private readonly _router = inject(Router);
  private readonly _systemLayoutService = inject(SystemLayoutService);

  datatable = viewChild.required<DataTableComponent>("adaaDataTable");

  private readonly _untilDestroyed = AdaaHelper.untilDestroyed();
  Constants = Constants;

  public ngOnInit(): void {
    this._systemLayoutService.hasActiveEntityChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => this.datatable().loadTableData(true),
    });

    this._systemLayoutService.hasCycleChanged$.pipe(this._untilDestroyed()).subscribe({
      next: () => this.datatable().loadTableData(true),
    });
  }

  public actionClicked(event: TableActionEvent): void {
    if (event.event === "edit") this._router.navigateByUrl(`console/forecasted-values/metrics/edit/${event.data.id}`);
    else if (event.event === "view") this._router.navigateByUrl(`console/forecasted-values/metrics/${event.data.id}`);
  }
}
